import { render, staticRenderFns } from "./PricingScheme.vue?vue&type=template&id=46712592&scoped=true"
import script from "./PricingScheme.vue?vue&type=script&lang=js"
export * from "./PricingScheme.vue?vue&type=script&lang=js"
import style0 from "./PricingScheme.vue?vue&type=style&index=0&id=46712592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46712592",
  null
  
)

export default component.exports